(function () {
    var syncingExclusiveGift = false;
    var syncTimer = null;

    function readCookie(name) {
        var value = '; ' + document.cookie;
        var parts = value.split('; ' + name + '=');
        if (parts.length === 2) return parts.pop().split(';').shift();
    }

    function giftIds() {
        return [
            window.cartgift_product1_id,
            window.cartgift_product2_id,
            window.cartgift_product3_id,
            window.cartgift_product4_id
        ].filter(Boolean).map(function (id) {
            return id.toString();
        });
    }

    function threshold(index) {
        var value = parseFloat(window['cartgift_level' + index]);
        if (!isNaN(value)) return value;

        var fallback = parseFloat($('.level-' + index).attr('data-max'));
        return isNaN(fallback) ? 0 : fallback;
    }

    function clampPercent(value) {
        if (isNaN(value)) return 0;
        return Math.max(0, Math.min(100, value));
    }

    function giftSubtotalCents(cart) {
        var ids = giftIds();
        return cart.items.reduce(function (total, item) {
            return ids.indexOf(item.id.toString()) === -1 ? total + item.final_line_price : total;
        }, 0);
    }

    function targetGiftId(eligibleTotal) {
        var ids = giftIds();
        for (var i = ids.length - 1; i >= 0; i -= 1) {
            if (ids[i] && eligibleTotal >= threshold(i + 1)) {
                return ids[i];
            }
        }
        return null;
    }

    function nextGiftIndex(eligibleTotal) {
        var ids = giftIds();
        for (var i = 0; i < ids.length; i += 1) {
            if (ids[i] && eligibleTotal < threshold(i + 1)) {
                return i + 1;
            }
        }
        return null;
    }

    function updateProgressText(eligibleTotal) {
        var nextIndex = nextGiftIndex(eligibleTotal);
        if (!nextIndex) {
            if (window.cartgift_level6 && window.cartgift_name6) {
                var discountAmount = Math.max(0, parseFloat(window.cartgift_level6) - eligibleTotal).toFixed(2);
                $('.amount-to-receive').text('$' + discountAmount);
                $('.product-to-receive').text(window.cartgift_name6);
            }
            return;
        }

        var amount = Math.max(0, threshold(nextIndex) - eligibleTotal).toFixed(2);
        $('.amount-to-receive').text('$' + amount);
        $('.product-to-receive').text(window['cartgift_name' + nextIndex] || 'your gift');
    }

    function updateProgressBars(eligibleTotal) {
        for (var i = 1; i <= 4; i += 1) {
            var min = i === 1 ? 0 : threshold(i - 1);
            var max = threshold(i);
            var percent = max > min ? ((eligibleTotal - min) / (max - min)) * 100 : 0;
            $('.progress-complete-' + i).css('width', clampPercent(percent) + '%');
        }
    }

    function updateGiftCards(targetId, present) {
        var ids = giftIds();
        $('.cart-flex .cart-gift').each(function () {
            var card = $(this);
            var wrapper = card.find('.product-wrapper');
            var id = wrapper.attr('data-id');

            if (!id || ids.indexOf(id.toString()) === -1) return;

            if (id.toString() === targetId && !present[id.toString()]) {
                card.show();
                card.find('.product-block').show();
            } else {
                card.hide();
            }
        });
    }

    function changeVariant(id, quantity) {
        return $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: { id: id, quantity: quantity },
            dataType: 'json'
        });
    }

    function addVariant(id) {
        return $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: { id: id, quantity: 1 },
            dataType: 'json'
        });
    }

    function runSequential(tasks) {
        return tasks.reduce(function (chain, task) {
            return chain.then(task);
        }, $.Deferred().resolve().promise());
    }

    function refreshCart() {
        if (typeof ShopifyAPI !== 'undefined' && typeof ShopifyAPI.getCart === 'function' && typeof buildCart === 'function') {
            ShopifyAPI.getCart(buildCart);
        }
    }

    function syncExclusiveGift() {
        if (syncingExclusiveGift) return;
        syncingExclusiveGift = true;

        $.getJSON('/cart.js', function (cart) {
            var ids = giftIds();
            var eligibleTotal = giftSubtotalCents(cart) / 100;
            var targetId = targetGiftId(eligibleTotal);
            var present = {};
            var tasks = [];

            cart.items.forEach(function (item) {
                var id = item.id.toString();
                if (ids.indexOf(id) !== -1) present[id] = item.quantity;
            });

            updateProgressBars(eligibleTotal);
            updateProgressText(eligibleTotal);
            updateGiftCards(targetId, present);

            ids.forEach(function (id) {
                if (id !== targetId && present[id]) {
                    tasks.push(function () { return changeVariant(id, 0); });
                }
            });

            if (targetId && !present[targetId] && readCookie(targetId) !== 'false') {
                tasks.push(function () { return addVariant(targetId); });
            }

            if (targetId && present[targetId] > 1) {
                tasks.push(function () { return changeVariant(targetId, 1); });
            }

            runSequential(tasks).always(function () {
                syncingExclusiveGift = false;
                if (tasks.length) setTimeout(refreshCart, 300);
            });
        }).fail(function () {
            syncingExclusiveGift = false;
        });
    }

    function scheduleExclusiveGiftSync() {
        clearTimeout(syncTimer);
        syncTimer = setTimeout(syncExclusiveGift, 2200);
    }

    var originalBuildCart = window.buildCart;
    window.buildCart = function (cart) {
        if (typeof originalBuildCart === 'function') originalBuildCart(cart);
        scheduleExclusiveGiftSync();
    };

    document.addEventListener('DOMContentLoaded', scheduleExclusiveGiftSync);
})();